import { lazy } from "react";

const routes = [
  {
    path: "/settings/roles",
    element: lazy(() => import("../../pages/Settings/Roles")),
  },
];

export default routes;
